var _class;
/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
import { Expression } from "abreact/expression/Expression";
import { InlinePanelLayout } from "abreact/expression/layout/InlinePanelLayout";
import { ArgumentOperandValueEditor } from "abreact/expression/ui/editor/impl/condition/operandValue/operand/argument/ArgumentOperandValueEditor";
import { ArgumentOperandIdentityImpl } from "abreact/expression/ui/editor/impl/factory/ArgumentOperandIdentityImpl";
import { SubExpressionOperandValueEditor } from "abreact/expression/ui/editor/impl/factory/subexpression/SubExpressionOperandValueEditor";
import { BooleanModelMediatorImpl } from "abreact/expression/ui/editor/impl/model/mediator/BooleanModelMediatorImpl";
import { GuidedExpressionEditorUtils } from "abreact/expression/ui/editor/impl/utils/GuidedExpressionEditorUtils";
import { Assert } from "abweb/utils/Assert";
import * as Immutable from "immutable";
import { observer } from "mobx-react";
import * as React from "react";
export let NonBooleanValueEditor = observer(_class = class NonBooleanValueEditor extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return this.createArgumentOperandEditor();
  }
  createArgumentOperandEditorProps(argumentOperand) {
    const operandValue = this.props.currentValue;
    let props = {
      isReadonly: false,
      sourceOperandValue: undefined,
      operatorOperandValue: this.props.operatorOperandValue,
      argumentOperandValuesByOperandName: Immutable.Map(),
      operandValue: operandValue,
      argumentOperand: argumentOperand,
      liveViewSliceModel: undefined,
      expressionDomainModel: this.props.expressionDomainModel,
      componentFactory: this.props.expressionComponentFactory,
      dataTestId: `${this.props.operandName}-input`,
      generateId: () => this.props.generateId(),
      applyOperandValue: this.props.applyOperandValue
    };
    return props;
  }
  createArgumentOperandEditor() {
    const argumentOperand = this.createArgumentOperand();
    let editor;
    if (this.props.operandName === "if") {
      editor = /*#__PURE__*/React.createElement(SubExpressionOperandValueEditor, {
        argumentOperandValueEditorProps: {
          ...this.createArgumentEditorProps(),
          dataTestId: `ab-gee-if-expression-${this.props.dataTestIdSuffix}`
        },
        modelMediator: this.getSubExpressionModelMediator(),
        componentFactory: this.props.expressionComponentFactory
      });
    } else {
      editor = /*#__PURE__*/React.createElement(ArgumentOperandValueEditor, this.createArgumentOperandEditorProps(argumentOperand));
    }
    return /*#__PURE__*/React.createElement(InlinePanelLayout.Item, null, editor);
  }
  createArgumentOperand() {
    const {
      operandName
    } = this.props;
    let operator = this.props.operatorOperandValue.expOperator;
    Assert.assert(operator != null);
    let argumentOperand = this.props.expressionDomainModel.getExpArgumentOperandForExpOperator(operator.id, operandName);
    if (!argumentOperand) {
      throw new Error(`Unable to find argument operand ${operandName} for  ${operator.id}`);
    }
    const argumentOperands = GuidedExpressionEditorUtils.getArgumentOperands(this.props.expressionDomainModel, undefined, operator);
    return argumentOperands.filter(o => o.expArgumentOperands.findIndex(arg => arg.name === operandName) > -1)[0];
  }
  createArgumentEditorProps() {
    const argumentOperand = this.createArgumentOperand();
    const expArgumentOperand = argumentOperand.expArgumentOperands.find(operand => operand.name === this.props.operandName);
    Assert.assert(expArgumentOperand != null); // Should not be hit since createArgumentOperand above matches on operand name.
    let identity = new ArgumentOperandIdentityImpl(this.props.expressionDomainModel.getExpValueCategory(Expression.Domain.Constants.CATEGORY_SUB_EXPRESSION), this.props.expressionDomainModel.getExpValueType(expArgumentOperand.valueTypeID), false, this.props.operatorOperandValue.expOperator, expArgumentOperand, argumentOperand.expArgumentOperandGroup, false);
    const baseProps = this.createArgumentOperandEditorProps(argumentOperand);
    Assert.assert(!baseProps.isReadonly);
    const argumentEditorProps = {
      ...baseProps,
      argumentOperandIdentity: identity,
      operandName: identity.operandName,
      applyOperandValue: operandValue => {
        this.props.applyOperandValue(this.props.operandName, operandValue);
      }
    };
    return argumentEditorProps;
  }
  getSubExpressionModelMediator() {
    return new BooleanModelMediatorImpl({
      expressionDomainModel: this.props.expressionDomainModel,
      summaryGenerator: this.props.expressionComponentFactory.getOperandValueSummaryGenerator()
    });
  }
}) || _class;
//# sourceMappingURL=NonBooleanValueEditor.js.map
